import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Settings/Routing/forms";
import headers from "../../../../Data/Forms/Settings/Routing/headers";
import toast from "react-hot-toast";
import { get_account_mapping, reset_account_mapping, create_update_account_mapping } from "../../../../Controllers/Settings/Routing";
import Loadercomponent from "../../../../Componets/Loader";

const AccountMappingForm = () => {
    let navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [resetLoader, setResetLoader] = useState(false);
    const [values, setValues] = useState(forms);
    const [header, setHeader] = useState(headers);

    console.log("Values", values);

    const getformdata = async (data) => {
        console.log("Form data", data);
    };

    const formdata = async (data) => {
        if (data?.status) {
            setButtonLoader(true);

            const item = await create_update_account_mapping(data?.data);

            if (item?.status || item?.success) {
                toast.success(item?.message);
                setButtonLoader(false);
                handleData(item?.data);
            } else {
                toast.error(item?.message);
                setButtonLoader(false);
            }
        }
    };

    const handleData = (mappingData) => {
        if (!mappingData) return;

        let sales_account = mappingData?.sales_account?._id ? mappingData?.sales_account?._id : null;
        let sales_account_option = mappingData?.sales_account?._id
            ? [{ value: mappingData?.sales_account?._id, label: mappingData?.sales_account?.name }]
            : null;

        let sales_return_account = mappingData?.sales_return_account?._id ? mappingData?.sales_return_account?._id : null;
        let sales_return_account_option = mappingData?.sales_return_account?._id
            ? [{ value: mappingData?.sales_return_account?._id, label: mappingData?.sales_return_account?.name }]
            : null;

        let purchase_account = mappingData?.purchase_account?._id ? mappingData?.purchase_account?._id : null;
        let purchase_account_option = mappingData?.purchase_account?._id
            ? [{ value: mappingData?.purchase_account?._id, label: mappingData?.purchase_account?.name }]
            : null;

        let purchase_return_account = mappingData?.purchase_return_account?._id ? mappingData?.purchase_return_account?._id : null;
        let purchase_return_account_option = mappingData?.purchase_return_account?._id
            ? [{ value: mappingData?.purchase_return_account?._id, label: mappingData?.purchase_return_account?.name }]
            : null;

        let inventory_account = mappingData?.inventory_account?._id ? mappingData?.inventory_account?._id : null;
        let inventory_account_option = mappingData?.inventory_account?._id
            ? [{ value: mappingData?.inventory_account?._id, label: mappingData?.inventory_account?.name }]
            : null;

        const newValues = [...values];

        newValues[0].options[0].form.value = sales_account;
        newValues[0].options[0].form.options = sales_account_option;

        newValues[0].options[1].form.value = sales_return_account;
        newValues[0].options[1].form.options = sales_return_account_option;

        newValues[0].options[2].form.value = purchase_account;
        newValues[0].options[2].form.options = purchase_account_option;

        newValues[0].options[3].form.value = purchase_return_account;
        newValues[0].options[3].form.options = purchase_return_account_option;

        newValues[0].options[4].form.value = inventory_account;
        newValues[0].options[4].form.options = inventory_account_option;

        setValues(newValues);
        setLoader(false);
    };

    const fetchData = async () => {
        setLoader(true);

        const item = await get_account_mapping();
        if (item?.status || item?.success) {
            if(item.message === "No account mapping found"){
                setLoader(false);
                return;
            }
            handleData(item?.data);
        } else {
            toast.error(item?.message);
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <div className="space-y-4">
                    <Forms
                        form={values}
                        setForm={setValues}
                        formdata={formdata}
                        buttonLoader={buttonLoader}
                        getformdata={getformdata}
                    />

                </div>
            </Loadercomponent>
        </Header>
    );
};

export default AccountMappingForm;